import React from 'react';
import { translate } from 'react-i18next';
import {Form, Button, Label, Icon, Header, Checkbox} from 'semantic-ui-react'

import SurveyButtons from './SurveyButtons.js';
import {colors, spacings, fontSizes, fonts} from 'style';
import styleDef from './style.js';

var style = {
    ...styleDef,
    multiSelectButton: {
        backgroundColor:'rgba(0,0,0,0)',
        color: colors.themeBlue,
        border: '1px solid ' + colors.themeBlue,
        marginTop: spacings.small,
        marginBottom: spacings.small,
        marginLeft: 'auto',
        marginRight: 'auto',
        width: '320px',
        ...fonts.body,
        lineHeight: '1.5',
        borderRadius: '100px',
    },
    activeButton: {
        color:'#fff',
        backgroundColor: colors.themeBlue,
    },
    toggleAnswer: {
        padding: spacings.base,
    },
    toggleAnswerText: {
        marginRight: '100px',
    },
    toggle: {
        marginTop: '10px',
        float: 'right',
    }
}

const SurveyPageMultiSelect = ({t,
                                surveyPage, 
                                inlineButtons, 
                                onSubmit, 
                                onSkip, 
                                pageNum, 
                                numPages, 
                                noPageNumbers,
                                buttonType,
                                onClick, 
                                isActive, 
                                valid, 
                                value}) => (
    <div style={style.container}>
    <div style={style.blank}>
        <div style={style.content}>

            <div style={style.header}>{surveyPage.title}</div>

            {Boolean(!noPageNumbers && numPages) &&
                <div style={style.pageCount}>
                    {t('page_{{pageNum}}_{{numPages}}',{pageNum, numPages})}
                </div>
            }


            <div style={style.description}>
                {surveyPage.description}
            </div>

            {Boolean(buttonType==='toggle') &&
                <br />
            }
           
            <div style={style.body}>
                {surveyPage.challenge.challengeAnswers.map((ca, index)=>{
                    switch(buttonType) {
                        case 'toggle': return (
                            <div key={ca.key} style={style.toggleAnswer}>
                                <Checkbox style={style.toggle} toggle checked={isActive(ca)} onChange={e=>onClick(ca)}/>
                                <div style={style.toggleAnswerText}>{ca.label}</div>
                            </div>
                        );
                        default: return (
                            <Button fluid 
                                    key={ca.key} 
                                    style={{...style.multiSelectButton, ...(isActive(ca) ? style.activeButton : {})}} 
                                    onClick={(e)=>{onClick(ca)}}>
                                {ca.label}
                            </Button>);
                    }
                })}
            </div>

                
            <SurveyButtons canSkip={surveyPage.canSkip} onSkip={onSkip} onSubmit={onSubmit} valid={valid} inlineButtons={inlineButtons} />
            {!inlineButtons &&
                <div style={style.spacer} />
            }

            {/*<pre style={{textAlign: 'left'}}>{JSON.stringify(survey,null,2)}</pre>*/}
        </div>
    </div>
    </div>
);

export default translate('surveys')(SurveyPageMultiSelect);



// WEBPACK FOOTER //
// ./src/modules/surveys/types/SurveyPageMultiSelect.js